export default __webpack_public_path__ + "static/media/tallify-order-sync.ff4681a8.png";